var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("bottom-toolbar"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-content" },
        [
          _c("div", { staticClass: "layoutTop" }),
          _vm._v(" "),
          _c(
            "f7-list",
            { attrs: { form: "" } },
            [
              _c(
                "f7-list-item",
                [
                  _c("f7-label", [_vm._v("Group name")]),
                  _vm._v(" "),
                  _c("f7-input", {
                    attrs: {
                      name: "groupName",
                      placeholder: "Group Name",
                      type: "text",
                    },
                    model: {
                      value: _vm.groupName,
                      callback: function ($$v) {
                        _vm.groupName = $$v
                      },
                      expression: "groupName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("f7-list-item", [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v("Service " + _vm._s(_vm.nameService)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item-after" }, [
                  _c("div", { staticClass: "item-input" }, [
                    _c("label", { staticClass: "label-switch" }, [
                      _c("input", {
                        staticClass: "checkService",
                        attrs: { type: "checkbox" },
                        domProps: { value: _vm.serviceActif },
                        on: { change: _vm.changeService },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("f7-list-item", [
                _c("div", { staticClass: "test-title subtitleDebtorList" }, [
                  _vm._v("Members"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "test-after" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "/accountMembers/addMemberGroupMembersList/",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "button button-round orangeBackground",
                          attrs: { href: "#" },
                        },
                        [_vm._v(_vm._s(this.selected.length) + " selected")]
                      ),
                    ]
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          Object.keys(this.selectedAccounts).length > 0
            ? _c("div", { staticClass: "contactGroupTitle" }, [
                _vm._v("Members in this group"),
              ])
            : _vm._e(),
          _vm._v(" "),
          Object.keys(this.selectedAccounts).length !== 0
            ? _c(
                "f7-list",
                _vm._l(this.selectedAccounts, function (value) {
                  return _c("f7-list-item", {
                    key: value.id,
                    attrs: { title: value.login },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "f7-button",
            {
              staticClass: "orangeConfirmationButton firstButtonMarginTop",
              attrs: { round: "", title: _vm.$t("common.negot") },
              on: { click: _vm.changeMemberGroup },
            },
            [_vm._v("\n        Save\n      ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "toolbarPageBottomBlank" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }